import { FunctionalComponent, h } from '@stencil/core';
import { AppRTE } from '.'

interface SectionTimeline {
    __component: string;
    data?: any;
}


export const SectionTimeline: FunctionalComponent<SectionTimeline> = ({ data }) => {

    const { Subtitle, Title, Events } = data;

    return (

        <section class="uk-section uk-position-relative">
            <div hidden={!Title} class="uk-container uk-margin-bottom uk-position-relative">
                <div class="uk-padding uk-padding-remove-top uk-padding-remove-left">
                    <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom">{Subtitle}</h2>
                    <h3 class="uk-heading-xlarge wsio-darker-green uk-width-1-1 uk-margin-remove">{Title}</h3>
                </div>
            </div>
            <div class="uk-container uk-container-large wsio-timeline-container">
                <div class="timeline">
                    <ul>
                        {Events.map(({ Title, Subtitle, Description }) =>
                            <li class="uk-background-primary-diag uk-light">
                                <div class="timeline-content">
                                    <h3 class="date uk-heading-small wsio-gold">{Subtitle}</h3>
                                    <h1>{Title}</h1>
                                    <AppRTE markdown={Description} />
                                </div>
                            </li>
                        )
                        }
                    </ul>
                </div>
            </div>
        </section>
    )
};